import { usePopup } from '@/composables/usePopup.ts'
import { computed } from 'vue'

export function usePopupOverlay(context) {
  const { popups } = usePopup()

  const overlayVisible = computed(() => {
    // Check if there are popups visible that show an overlay in the same
    // overlay context.
    const visibleOverlays = Object.entries(popups.value)
      .filter((entry) => {
        const popup = entry[1]
        return popup.visible &&
          popup.showOverlay &&
          popup.overlayContext === context
      })
    return visibleOverlays.length > 0
  })

  return {
    overlayVisible,
  }
}